"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Queue functions to send logs
 */
var Queue = /*#__PURE__*/function () {
  /**
   * Construct a Queque
   */
  function Queue() {
    _classCallCheck(this, Queue);
    this.first = 0;
    this.last = 0;
    this.storage = {};
  }
  /**
   * Set a enqueue in the queue
   *
   * @param {*} value The log entry
   */
  return _createClass(Queue, [{
    key: "enqueue",
    value: function enqueue(value) {
      // handles both individual objects and arrays of objects
      if (Array.isArray(value)) {
        // iterate over array, enqueueing each item
        var _iterator = _createForOfIteratorHelper(value),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (Array.isArray(item)) {
              this.enqueue(item);
            } else {
              this.storage[this.last] = item;
              this.last++;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        this.storage[this.last] = value;
        this.last++;
      }
    }

    /**
     * Set a dequeue in the queue
     *
     * @return {*} The value associed with the dequeue
     */
  }, {
    key: "dequeue",
    value: function dequeue() {
      if (this.last > this.first) {
        var value = this.storage[this.first];
        delete this.storage[this.first];
        this.first++;
        return value;
      } else {
        return null;
      }
    }

    /**
     * Set a size in the queue
     *
     * @return {*} The size of the queue
     */
  }, {
    key: "size",
    value: function size() {
      return this.last - this.first;
    }
    /**
     * Set a drain in the queue
     *
     * @return {*} The array of logs
     */
  }, {
    key: "drain",
    value: function drain() {
      var contentsArray = [];
      var dequeuedValue = null;
      while (dequeuedValue = this.dequeue()) {
        contentsArray.push(dequeuedValue);
      }
      return contentsArray;
    }
  }]);
}();
var _default = exports["default"] = Queue;
//# sourceMappingURL=queue.js.map